import { pricingConfig } from '../data/pricing';
import type { Bundle } from '../data/pricing';

export type PositionPlan = {
  bundle: Bundle;
  installed: number;
  backups: number;
  /** True when the system exactly matches the request (no extra lights). */
  exact: boolean;
};

/**
 * Smallest official system that covers `positions` installed lights,
 * plus an equal backup set when `withBackups` is on.
 */
export function planForPositions(positions: number, withBackups: boolean): PositionPlan {
  const needed = withBackups ? positions * 2 : positions;
  const sorted = [...pricingConfig.bundles].sort((a, b) => a.qty - b.qty);
  const bundle = sorted.find((b) => b.qty >= needed) ?? sorted[sorted.length - 1];
  const installed = Math.min(positions, bundle.qty);
  return { bundle, installed, backups: bundle.qty - installed, exact: bundle.qty === needed };
}
